<script setup>
import { computed } from 'vue'
import { offline } from '@/lib/offline.js'
import { formatRelative } from '@/lib/format.js'

/** Online / offline, queued changes, conflicts — one glance, one click to the sync screen. */
const s = offline.state
const tone = computed(() => {
  if (s.conflicts || s.failed) return 'bg-red-100 text-red-800 dark:bg-red-900/50 dark:text-red-100'
  if (!s.online) return 'bg-amber-100 text-amber-900 dark:bg-amber-900/50 dark:text-amber-100'
  if (s.pending) return 'bg-blue-100 text-blue-800 dark:bg-blue-900/50 dark:text-blue-100'
  return 'text-muted hover:bg-[var(--surface-3)]'
})
const title = computed(() => (s.lastPullAt ? formatRelative(s.lastPullAt) : ''))
</script>

<template>
  <router-link :to="{ name: 'sync' }" :class="['inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium', tone]" :title="title" data-testid="sync-indicator">
    <i :class="['fa-solid', s.syncing ? 'fa-rotate fa-spin' : s.online ? 'fa-cloud' : 'fa-plane']" aria-hidden="true"></i>
    <span class="hidden sm:inline">{{ s.online ? $t('sync.online') : $t('sync.offline') }}</span>
    <span v-if="s.pending" class="rounded-full bg-white/70 px-1.5 dark:bg-black/30">{{ s.pending }}</span>
    <i v-if="s.conflicts || s.failed" class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
  </router-link>
</template>
